import * as AWS from 'aws-sdk';

import {Inject, Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {UrlUtils} from "./url.utils";
import {ConfigurationService} from "../services/configuration.service";

@Injectable()
export class UploadFileServiceUtils {

  progress: number = 0;
  speed: number = 0;
  unit: string = "Mbps";

  private startTime: any;
  private currTime: any;
  private prevTime: any;
  private bytesReceived: number = 0;
  private oldBytes: number = 0;

  private awsIdentityPoolIdRegion: string;

  constructor(
    private readonly router: Router,
    @Inject('UrlUtils') private readonly urlUtils: UrlUtils,
    @Inject('ConfigurationService') private readonly configurationService: ConfigurationService
  ) {
    configurationService.getSettings().subscribe(settings => {
      this.awsIdentityPoolIdRegion = settings.awsIdentityPoolIdRegion;
    });
  }

  uploadFile(bucketName, key, file, metadata): Promise<String> {

    AWS.config.region = this.awsIdentityPoolIdRegion;
    if ((<AWS.CognitoIdentityCredentials>AWS.config.credentials).needsRefresh()) {
      (<AWS.CognitoIdentityCredentials>AWS.config.credentials).refresh((error) => {
        if (error != null) {
          console.log("Error while refreshing credentials: " + error.message);
        }
      });
    }
    let upload = new AWS.S3.ManagedUpload({
      params: {
        Bucket: bucketName,
        Key: key,
        Body: file,
        Metadata: metadata
      }
    });

    console.log('File Upload Started!');

    return new Promise((resolve, reject) => {

      upload.on('httpUploadProgress', (event) => {

        //tracking percent received and how much time has passed
        this.progress = Math.round((100 * event.loaded) / event.total);
        if (this.progress % 5 == 0) {
          console.log("Progress : ", this.progress)
        }
        this.currTime = new Date().getTime();

        //setting start time
        if (this.progress === 0) {
          this.startTime = new Date().getTime();
          this.prevTime = this.startTime;
        }

        //tracking how much data is received
        this.bytesReceived = event.loaded / 1000000;

        //calculating download speed per percent data received
        this.speed =
          (this.bytesReceived - this.oldBytes) /
          ((this.currTime - this.prevTime) / 1000);
        if (this.speed < 1) {
          this.unit = "Kbps";
          this.speed *= 1000;
        } else this.unit = "Mbps";

        //updating previous values
        this.prevTime = this.currTime;
        this.oldBytes = this.bytesReceived;
        this.speed = Math.round(100 * this.speed) / 100;

      }).send((err, data) => {
        this.progress = 0;
        if (data)
          resolve(data);
        else
          reject(err);
      })
    });
  }
}
